import http from '../http';

// 获取部分结账信息
const fetchPartSettleInfo = (data) => {
  return http({
    url: '/bill/settle/part',
    method: 'POST',
    data,
  });
};

export { fetchPartSettleInfo };
